import { Link } from "react-router-dom";

export default function ProductCard({ product, index = 0 }) {
  const img = (product.images || [])[0] || "/images/custom_object.jpeg";
  return (
    <Link
      to={`/produit/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group card-hover block rounded-2xl overflow-hidden bg-[#0A0A0A] border border-[#222]"
    >
      <div className="aspect-square overflow-hidden bg-black relative">
        <div className="absolute inset-0">
          <img src={img} alt={product.name}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        </div>
      </div>
      <div className="p-4">
        <p className="text-xs uppercase tracking-wider text-[#0055FF] font-semibold">{product.material}</p>
        <h3 className="mt-1 font-heading font-bold text-white text-base leading-tight line-clamp-2">{product.name}</h3>
        <div className="mt-3 flex items-center justify-between">
          <span className="text-lg font-black text-[#E6007E]">{product.price.toFixed(2)} €</span>
          <span className="text-sm font-bold text-white rounded-full border border-[#E6007E]/50 px-3 py-1 group-hover:bg-[#E6007E] transition-colors">
            Voir
          </span>
        </div>
      </div>
    </Link>
  );
}
